export default {"src":"/_next/static/media/download_24.cf184c6c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};